import React from "react";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@src/lib/ui/AlertDialog";
import { Button } from "@src/lib/ui/Button";
import { useSetAgentArchived } from "@src/features/opus-agent/agentPanel";
import { OpusAgentFieldsFragment } from "@src/features/opus-agent/agentPanel.generated";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  agent: Pick<OpusAgentFieldsFragment, "id" | "name">;
};

const ArchiveAgentDialog: React.FC<Props> = ({ open, onOpenChange, agent }) => {
  const { setArchived, loading } = useSetAgentArchived();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Archive {agent.name}?</AlertDialogTitle>
          <AlertDialogDescription>
            It leaves the Agents list for everyone in your organization. Its
            chat is kept, and you can unarchive it from Archived at any time.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            loading={loading}
            data-testid="archive-agent-confirm"
            onClick={async () => {
              if (await setArchived(agent, true)) onOpenChange(false);
            }}
          >
            Archive
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ArchiveAgentDialog;
